import {
  Container,
  CssBaseline,
  Box,
  Grid,
  Typography,
  Button,
  Tooltip
} from '@mui/material';
import { React } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './all-you-need.module.scss';
import Images from '../../../assets/img';
import reactGA from 'react-ga';
import i18next from 'i18next';

export default function AllWeNeedIsHere() {
  const history = useHistory();
  return (
    <>
      <CssBaseline />
      <Box
        className={`${styles['allyouneed-section-wrapper']}`}
        pt={10}
        pb={10}
        px={12}
        sx={{ backgroundColor: 'primaryBackground.bgBody' }}
      >
        <Container
          sx={{
            paddingLeft: {
              xs: '1rem',
              sm: '2rem',
              md: '3rem',
              lg: '5rem',
              xl: '5rem'
            }
          }}
        >
          <Grid container md={12} sm={12} xs={12}>
            <Grid
              item
              md={12}
              sm={12}
              xs={12}
              className={`${styles['allyouneed-section-heading-wrapper']}`}
            >
              <Typography
                className={`${styles['allyouneed-section-heading']}`}
                component='h2'
                variant='h5'
                mb={'10px'}
              >
                {i18next.t('HOME_PAGE.HEADER_FOOTER.MOBILITY_MARKETPLACE')}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            md={12}
            sm={12}
            xs={12}
            className={`${styles['allyouneed-section-grid-container']}`}
          >
            <Grid
              container
              md={6}
              xs={12}
              className={`${styles['allyouneed-section-features-wrapper']}`}
            >
              <Grid
                item
                md={12}
                xs={12}
                className={`${styles['allyouneed-section-content-container']}`}
              >
                <Typography className={`${styles['allyouneed-section-content']}`}>
                  {i18next.t('HOME_PAGE.ALL_YOU_NEED.BODY_1')}
                </Typography>
              </Grid>
              <Grid
                item
                md={12}
                xs={12}
                pt={'1rem'}
                className={`${styles['allyouneed-section-content-container']}`}
              >
                <Typography className={`${styles['allyouneed-section-content']}`}>
                  {i18next.t('HOME_PAGE.ALL_YOU_NEED.BODY_2')}
                </Typography>
              </Grid>
              <Grid
                container
                md={12}
                xs={12}
                sm={12}
                className={`${styles['allyouneed-section-btn-container']}`}
                spacing={1}
              >
                <Grid
                  item
                  md={12}
                  mt={3}
                  sm={12}
                  xs={12}
                  pt={20}
                  className={`${styles['allyouneed-section-btn-wrapper']}`}
                >
                  <Button
                    variant='borderedBtn'
                    onClick={() => {
                      history.push('/about-us');
                      reactGA.event({
                        category: 'Know More',
                        action: 'User Clicked on Know More',
                        label: 'Know More'
                      });
                    }}
                  >
                    {' '}
                    {i18next.t('HOME_PAGE.ALL_YOU_NEED.KNOW_MORE')}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              md={5.5}
              xs={12}
              className={`${styles['allyouneed-section-video-container']}`}
            >
              <Grid
                item
                md={12}
                xs={12}
                className={`${styles['allyouneed-section-video-wrapper']}`}
              >
                <Tooltip>
                  <Box
                    component='img'
                    src={Images.connectedSolutionsDashboard}
                    alt={i18next.t('IMAGE_ALT_TEXT.CAMPAIGN_SECTION.PLAYBACKIMG')}
                    className={styles['allyouneed-section-image']}
                  />
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
}
